import { useAppContext } from '../../../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { updateData, postData } from '../../../services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faPlus } from '@fortawesome/free-solid-svg-icons';
import Modal from '../../helpers/Modal';
export const NewTaskForm = ({ project }) => {
    const { token, base_url, setProjects, user, invoices } = useAppContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();

    const team = [
        'ashley@mtsolar.us',
        'christina@mtsolar.us',
        'jamie@mtsolar.us',
        'jennifer@mtsolar.us',
        'jeremy@mtsolar.us',
        'kris@mtsolar.us',
        'mike.henderson@mtsolar.us',
        'noel@mtsolar.us',
        'developer@mtsolar.us',
        'andrew@mtsolar.us',
        'penni@mtsolar.us',
        'janelle@mtsolar.us',
        'packaging@mtsolar.us',
        'alex@mtsolar.us'
    ]

    const taskStatuses = ['Not Started', 'In Progress', 'On Hold', 'Completed'];

    const initialFormData = {
        task_name: '',
        task_description: '',
        assigned_to: '',
        due_date: '',
        status: 'Not Started',
        task_level: 'Project',
        design_unique_id: '',
        created_by: user.email,
        response: ''
    };
    const [formData, setFormData] = useState(initialFormData);

    const projectInvoice = (invoices || []).find((invoice) => invoice.project_site_id === project.id);
    const designOptions = Array.isArray(projectInvoice?.included_designs)
        ? projectInvoice.included_designs
        : Array.isArray(projectInvoice?.includedDesigns)
            ? projectInvoice.includedDesigns
            : [];

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (isSubmitting) return; // Prevent multiple submissions

        setIsSubmitting(true);

        // Get current tasks and add the new one
        const currentTasks = project.project_tasks || [];
        const today = new Date().toISOString().split('T')[0];
        
        const newTask = {
            ...formData,
            created_at: today,
            updated_at: today
        };

        const updatedTasks = [...currentTasks, newTask];

        const data = {
            project_tasks: updatedTasks
        };

        try {
            console.log('Creating new task for project:', project.id);
            const updated_project = await updateData(token, `${base_url}/apis/projects/${project.id}`, data);
            if (updated_project.project) {
                // Update the project in context
                setProjects(prevProjects => 
                    prevProjects.map(p => 
                        p.id === project.id ? updated_project.project : p
                    )
                );

                // Notify the assigned user about the new task
                await postData(token, `${base_url}/apis/alerts/new-task/${formData.assigned_to}`, newTask);

                // Show success alert
                window.showAlert(200, 'Task created successfully!');
                console.log('Task created successfully!');
                
                // Reset form
                setFormData(initialFormData);
                
                // Close modal on success
                setIsModalOpen(false);
                
                // Refresh the page
                navigate(`/project/${project.id}`);
            }
        } catch (error) {
            console.error('Error creating task:', error);
            
            // Show error alert based on error type
            if (error.status === 404) {
                window.showAlert(404, 'Project not found');
            } else if (error.status >= 400 && error.status < 500) {
                window.showAlert(error.status, 'Invalid task data. Please check your input.');
            } else {
                window.showAlert(500, 'Failed to create task. Please try again.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
            ...(name === 'task_level' && value === 'Project' ? { design_unique_id: '' } : {})
        }));
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setFormData(initialFormData);
        setIsSubmitting(false);
    };

    const newTaskForm = (
        <div>
            <h2 className="modal-title modal-title--compact">New Task</h2>
            <form onSubmit={handleSubmit} className="company-form-grid">
                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="task_name" className="form-label">
                            Task Name *
                        </label>
                        <input
                            type="text"
                            id="task_name"
                            name="task_name"
                            value={formData.task_name}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Enter task name"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="task_level" className="form-label">
                            Task Level *
                        </label>
                        <select
                            id="task_level"
                            name="task_level"
                            value={formData.task_level}
                            onChange={handleChange}
                            className="form-input"
                            required
                        >
                            <option value="Project">Project</option>
                            <option value="Design">Design</option>
                        </select>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="task_description" className="form-label">
                            Task Description
                        </label>
                        <textarea
                            id="task_description"
                            name="task_description"
                            value={formData.task_description}
                            onChange={handleChange}
                            rows="3"
                            className="form-textarea"
                            placeholder="Describe the task..."
                        />
                    </div>
                </div>

                {formData.task_level === 'Design' && (
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="design_unique_id" className="form-label">
                                Design *
                            </label>
                            <select
                                id="design_unique_id"
                                name="design_unique_id"
                                value={formData.design_unique_id}
                                onChange={handleChange}
                                className="form-input"
                                required
                                disabled={designOptions.length === 0}
                            >
                                <option value="">
                                    {designOptions.length > 0 ? 'Select design' : 'No designs available'}
                                </option>
                                {designOptions.map((designId) => (
                                    <option key={designId} value={designId}>
                                        {designId}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="assigned_to" className="form-label">
                            Assigned To *
                        </label>
                        <select
                            id="assigned_to"
                            name="assigned_to"
                            value={formData.assigned_to}
                            onChange={handleChange}
                            className="form-input"
                            required
                        >
                            <option value="">Select team member</option>
                            {team.map((email) => (
                                <option key={email} value={email}>
                                    {email}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="status" className="form-label">
                            Status *
                        </label>
                        <select
                            id="status"
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                            className="form-input"
                            required
                        >
                            {taskStatuses.map((status) => (
                                <option key={status} value={status}>
                                    {status}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="due_date" className="form-label">
                            Due Date *
                        </label>
                        <input
                            type="date"
                            id="due_date"
                            name="due_date"
                            value={formData.due_date}
                            onChange={handleChange}
                            className="form-input"
                            required
                        />
                    </div>
                </div>

                <div className="form-actions">
                    <button
                        type="button"
                        onClick={closeModal}
                        className="btn btn-secondary"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <>
                                <FontAwesomeIcon icon={faSpinner} spin /> Creating...
                            </>
                        ) : (
                            'Create Task'
                        )}
                    </button>
                </div>
            </form>
        </div>
    );

    // Only show the button if user is super admin
    if (!user || !user.is_super_admin) {
        return null;
    }

    return (
        <div>
            <button 
                className="btn btn-action btn-primary" 
                onClick={() => setIsModalOpen(true)}
            >
                <FontAwesomeIcon icon={faPlus} /> New Task
            </button>
            {isModalOpen && (
                <Modal form={newTaskForm} setIsModalOpen={closeModal} isWide fitContent />
            )}
        </div>
    );
};

